import { NgModule } from '@angular/core';
// Required services for navigation
import { Routes, RouterModule } from '@angular/router';

// Import all the components for which navigation service has to be activated 
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { AuthGuard } from "./shared/guard/auth.guard";
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { LedgerComponent } from './ledger/ledger.component';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet.component';
import { IncomeStatementComponent } from './income-statement/income-statement.component';
import { StorageComponent } from './storage/storage.component';
import { SenseComponent } from './sense/sense.component';
import { SalesComponent } from './sales/sales.component';
import { OrdersComponent } from './orders/orders.component';
import { PrivilegeComponent as PrivilegeComponent } from './components/privilege/privilege.component';
import { MessagesComponent } from './components/messages/messages.component';
import { LedgerApComponent } from './ledger-ap/ledger-ap.component';
import { LedgerArComponent } from './ledger-ar/ledger-ar.component';
import { LedgerCostComponent } from './ledger-cost/ledger-cost.component';
import { StorageMaterialComponent } from './storage-material/storage-material.component';
import { CashStatementComponent } from './cash-statement/cash-statement.component';

const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-up', component: SignUpComponent, canActivate: [AuthGuard] },
  { path: 'privilege', component: PrivilegeComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'messenger', component: MessagesComponent, canActivate: [AuthGuard] },
  { path: 'ledger', component: LedgerComponent, canActivate: [AuthGuard] },
  { path: 'ledger-ar', component: LedgerArComponent, canActivate: [AuthGuard] },
  { path: 'ledger-ap', component: LedgerApComponent, canActivate: [AuthGuard] },
  { path: 'ledger-cost', component: LedgerCostComponent, canActivate: [AuthGuard] },

  { path: 'balance-sheet', component: BalanceSheetComponent, canActivate: [AuthGuard] },
  { path: 'income-statement', component: IncomeStatementComponent, canActivate: [AuthGuard] },
  { path: 'cash-statement', component: CashStatementComponent, canActivate: [AuthGuard] },

  { path: 'storage', component: StorageComponent, canActivate: [AuthGuard] },
  { path: 'storageMaterial', component: StorageMaterialComponent, canActivate: [AuthGuard] },

  { path: 'sales', component: SalesComponent, canActivate: [AuthGuard] },
  { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
  { path: 'sense', component: SenseComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }